var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"404","title":"404","sub-title":"抱歉，您访问的页面不存在"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"link"},on:{"click":_vm.onClickFeedback}},[_vm._v(" 反馈 ")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.onClickBack}},[_vm._v(" 返回主页 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }